import * as Sentry from '@sentry/react';

Sentry.init({
    dsn: 'https://9ce3c97a95c567090d21911d9183aa66@o4506463608176640.ingest.us.sentry.io/4506463617024000',
    integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration({
            maskAllText: false,
            blockAllMedia: false,
        }),
        Sentry.feedbackIntegration({
            colorScheme: 'system',
            autoInject: false
        }),
    ],
    // Performance Monitoring
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Enable session replay in production only for specific users
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1,
    environment: import.meta.env.VITE_ENVIRONMENT,
    // Disable Sentry in development
    enabled:  import.meta.env.VITE_ENVIRONMENT !== 'development',
});
